import {
  CircleWrapper,
  Circle,
  Label,
  Section,
  SectionWrapper,
  Icon,
} from "./style";
import { PageContainer } from "../../styles/sharedStyled";
import { HeartIcon, DiamondIcon, FloatingLeaf } from "../../shared/icons";

const FeatureAbout = () => {
  return (
    <SectionWrapper>
      <PageContainer>
        <h2>
          Partnering for a Greener Future: Building Sustainable Impact with
          Environmental Leaders
        </h2>
      </PageContainer>

      <Section>
        <CircleWrapper>
          <Circle bgColor={"#E7EFFF"}>
            <Icon>
              <HeartIcon />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#FFDFDF"}>
            <Icon>
              <DiamondIcon />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#FFEFC6"}>
            <Icon>
              <FloatingLeaf />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#E7EFFF"}>
            <Icon>
              <HeartIcon />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#F0F0F0"}>
            <Icon>
              <FloatingLeaf />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#FFDFDF"}>
            <Icon>
              <DiamondIcon />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
        <CircleWrapper>
          <Circle bgColor={"#F0F0F0"}>
            <Icon>
              <FloatingLeaf />
            </Icon>
          </Circle>
          <Label>Brand</Label>
        </CircleWrapper>
      </Section>
    </SectionWrapper>
  );
};

export default FeatureAbout;
